import { FC } from 'react';
import { BannerList } from '../BannerList/BannerList';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { Banner } from '@/types/api/bannerApi';

interface ServiceProps {
  id: number;
  categoryName?: string;
  banners?: Banner[];
}

export const Service: FC<ServiceProps> = ({
  categoryName,
  banners,
}) => {
  return (
    <PageTemplate
      pageName="Service"
      title={categoryName || 'サービス'}
      showNavBack
    >
      {/*
      2025/4/23 コメントアウト指示
      https://rebootkumiai-my.sharepoint.com/:p:/g/personal/yun_reboot_vision/ERi21yPMmX5KlsYOz3OEm88BQPF34ZvHJFnU5fDaAO-09w?e=16Rcch&nav=eyJzSWQiOjI4MCwiY0lkIjozMzMxMDExODZ9
      サービスカード・見出し・ガソリンスタンド検索を非表示
      */}

      {banners && <BannerList banners={banners} />}
    </PageTemplate>
  );
};
